module.exports = __webpack_public_path__ + "static/media/favicon_package_v0.16.d89d9ed7.zip";